// extracted by mini-css-extract-plugin
export default {"text":"numberText_text__t+rwG","symbol":"numberText_symbol__p0bVo"};